import type { ApiSingleResponse } from '@/types/api.config';
import type {
  PaymentHistoryResult,
  PaymentStatus,
  ReceiptContent,
  RepaymentContent,
  UsageSummaryContent,
} from '@/types/billing';
import { api } from '../api.service';

export const billingService = {
  getUsage: (
    period: string,
    organizationId?: string
  ): Promise<ApiSingleResponse<UsageSummaryContent>> => {
    return api.billing.get<ApiSingleResponse<UsageSummaryContent>>(
      '/v1/billing/usage',
      {
        period,
        ...(organizationId && { organizationId }),
      }
    );
  },

  getPaymentHistory: (params: {
    startPeriod: string;
    endPeriod: string;
    paymentStatus?: PaymentStatus;
    page?: number;
    size?: number;
  }): Promise<{
    header: {
      resultCode: number;
      resultMessage: string;
      isSuccessful: boolean;
    };
    result: PaymentHistoryResult;
  }> => {
    return api.billing.get('/v1/billing/paymentHistory', {
      ...params,
    });
  },

  repayment: (
    paymentNo: string
  ): Promise<ApiSingleResponse<RepaymentContent>> => {
    return api.billing.post<ApiSingleResponse<RepaymentContent>>(
      '/v1/billing/repayment',
      { paymentNo }
    );
  },

  getReceipt: (
    paymentNo: string
  ): Promise<ApiSingleResponse<ReceiptContent>> => {
    return api.billing.get<ApiSingleResponse<ReceiptContent>>(
      '/v1/billing/receipt',
      { paymentNo }
    );
  },
};
